<template>
  <button ref="trigger" class="facet-info-btn" type="button" @click.stop>?</button>
</template>

<script>
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export default {
  name: 'FacetInfoTooltip',
  props: {
    text: { type: String, required: true },
    linkUrl: { type: String, default: null },
    linkText: { type: String, default: null },
  },
  mounted() {
    const content = document.createElement('div');
    content.className = 'facet-tooltip-content';

    const textNode = document.createElement('span');
    textNode.textContent = this.text;
    content.appendChild(textNode);

    if (this.linkUrl && this.linkText) {
      const link = document.createElement('a');
      link.href = this.linkUrl;
      link.textContent = this.linkText;
      link.className = 'facet-tooltip-link';
      link.target = '_blank';
      link.rel = 'noopener';
      content.appendChild(document.createTextNode(' '));
      content.appendChild(link);
    }

    this._tippy = tippy(this.$refs.trigger, {
      content,
      trigger: 'click mouseenter focus',
      interactive: true,
      placement: 'right',
      arrow: true,
      maxWidth: 280,
      theme: 'facet-info',
      appendTo: document.body,
    });
  },
  beforeDestroy() {
    if (this._tippy) {
      this._tippy.destroy();
    }
  },
}
</script>
